import firebaseConfig from "../fb.json";

const pid = firebaseConfig.projectId;

export function fnUrl(name: string): string {
  return window.location.hostname === "localhost"
    ? `http://127.0.0.1:5005/${pid}/us-central1/${name}`
    : `https://us-central1-${pid}.cloudfunctions.net/${name}`;
}
